// extracted by mini-css-extract-plugin
export var productImage = "_kf-1";
export var viewLink = "_kf-2";
export var wishlistItem = "_kf-0";